import { useContext, useEffect } from 'react'
import MasterModalContext from 'contexts/MasterModalContext'
import GeoContext from 'contexts/geoContext'
import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'
import { TryShowModalContext } from 'contexts/ModalProvider'
import config from 'constants/config'
import ThereNoPlaceLikeHomePopup from 'home/components/Trip/ThereNoPlaceLikeHomePopup'
import {
  getThereNoPlaceLikeHomePopupExperimentVariant,
  getThereNoPlaceLikeHomePopupMarket,
} from 'home/components/Trip/thereNoPlaceLikeHomePopupConfig'
import {
  hasSeenThereNoPlaceLikeHomePopup,
  hasSnoozedThereNoPlaceLikeHomePopupForSession,
  markThereNoPlaceLikeHomePopupAsSeen,
} from 'home/components/Trip/thereNoPlaceLikeHomePopupStorage'
import { useAppSelector } from 'hooks/reduxHooks'
import { isCurrentDeviceMobileOrTablet } from 'selectors/configSelectors'

function useShowThereNoPlaceLikeHomePopup() {
  const tryShowModal = useContext(TryShowModalContext)
  const modalState = useContext(MasterModalContext)
  const { currentRegionCode, geoStateName } = useContext(GeoContext)
  const { triggerActivation } = useExperiment(Experiments.thereNoPlaceLikeHomePopup, { canActivate: false })
  const thereNoPlaceLikeHomePopupExperiment = useAppSelector(
    state => state.optimizely.optimizelyExperiments[Experiments.thereNoPlaceLikeHomePopup.id],
  )
  const isMobileOrTabletDevice = useAppSelector(isCurrentDeviceMobileOrTablet)
  const thereNoPlaceLikeHomePopupVariant = getThereNoPlaceLikeHomePopupExperimentVariant(
    thereNoPlaceLikeHomePopupExperiment,
    isMobileOrTabletDevice,
  )
  const thereNoPlaceLikeHomePopupMarket = getThereNoPlaceLikeHomePopupMarket(currentRegionCode, geoStateName)

  useEffect(() => {
    if (
      !config.ENABLE_TRIP_PLANNER ||
      !thereNoPlaceLikeHomePopupMarket ||
      !thereNoPlaceLikeHomePopupVariant ||
      modalState.open ||
      hasSeenThereNoPlaceLikeHomePopup() ||
      hasSnoozedThereNoPlaceLikeHomePopupForSession()
    ) {
      return
    }

    const popup = tryShowModal(
      <ThereNoPlaceLikeHomePopup market={thereNoPlaceLikeHomePopupMarket} variant={thereNoPlaceLikeHomePopupVariant} />,
    )
    if (!popup) {
      return
    }

    triggerActivation()
    markThereNoPlaceLikeHomePopupAsSeen()
  }, [modalState.open, triggerActivation, tryShowModal, thereNoPlaceLikeHomePopupMarket, thereNoPlaceLikeHomePopupVariant])
}

export default useShowThereNoPlaceLikeHomePopup
